module.exports = __webpack_public_path__ + "img/personalZhM.69476724.jpg";